import KeyFlowVO from 'commons/vo/KeyFlowVO';

interface UserVOProps {
  ID: string;
  PID: string;
  USER_ID: string;
  NAME: string;
  PASSWD: string;
  TYPE: string;
  AUTHORITIES: { role: string }[];
  DEPARTMENT: string;
  CLASS: string;
  EMAIL: string;
  PHONE: string;
  CELLPHONE: string;
  HASPERIOD: string;
  STARTDATE: string;
  ENDDATE: string;
  CAN_ACCESS_CATEGORY_LIST: string;
  CREATEDATE: string;
  CREATEUSER: string;
  MODIFYDATE: string;
  MODIFYUSER: string;
}

class UserVO extends KeyFlowVO {
  id: string;
  pid: string;
  userId: string;
  name: string;
  password: string;
  type: string;
  authorities: { role: string }[];
  department: string;
  class: string;
  email: string;
  phone: string;
  cellphone: string;
  hasPeriod: string;
  startDate: string;
  endDate: string;
  canAccessCategoryList: string;
  createDate: string;
  createUser: string;
  modifyDate: string;
  modifyUser: string;

  constructor(data: UserVOProps) {
    super(data);
    this.id = data.ID;
    this.pid = data.PID;
    this.userId = data.USER_ID;
    this.name = data.NAME;
    this.password = data.PASSWD;
    this.type = data.TYPE;
    this.authorities = data.AUTHORITIES;

    this.department = data.DEPARTMENT;
    this.class = data.CLASS;
    this.email = data.EMAIL;
    this.phone = data.PHONE;
    this.cellphone = data.CELLPHONE;
    this.hasPeriod = data.HASPERIOD;
    this.startDate = data.STARTDATE;
    this.endDate = data.ENDDATE;

    this.canAccessCategoryList = data.CAN_ACCESS_CATEGORY_LIST;
    this.createDate = data.CREATEDATE;
    this.createUser = data.CREATEUSER;
    this.modifyDate = data.MODIFYDATE;
    this.modifyUser = data.MODIFYUSER;
  }
}

export default UserVO;
